import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import AppRoutes from './routes/AppRoutes';
import { NavbarProvider } from './context/NavbarContext';
import createAppTheme from './theme/muiTheme';
import useColorMode, { ColorModeProvider } from './hooks/useColorMode';

function AppContent() {
  const { mode } = useColorMode();
  const theme = createAppTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NavbarProvider>
        <AppRoutes />
      </NavbarProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ColorModeProvider>
      <AppContent />
    </ColorModeProvider>
  );
}

export default App;
